//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Instructor',
  data () {
    return {
      courses: {
        LIVESTREAM: [],
        VIDEO: [],
        TEXT: [],
        WEBINAR: [],
        PODCAST: [],
        LIVE: [],
      },
      instructor: {},
      loading: true,
    };
  },
  head () {
    return {
      title: this.instructor.firstName + ' ' + this.instructor.lastName,
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          content: this.instructor.firstName + ' ' + this.instructor.lastName,
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: this.truncatedBio,
        },
        {
          hid: 'description',
          name: 'description',
          content: this.truncatedBio,
        },
      ],
    };
  },
  computed: {
    truncatedBio () {
      if (process.client) {
        const stripHtmlTags = (html) => {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
          return tempDiv.textContent || tempDiv.innerText || '';
        };

        const bioText = stripHtmlTags(this.instructor.bio);
        if (bioText.length > 160) {
          return bioText.substring(0, 160) + '...';
        }
        return bioText;
      }
      return '';
    },
  },
  async beforeMount () {
    this.info = await this.$axios.$get(`/search/instructor/${this.$route.params.instructor}`);
    this.courses = this.info.sessions;
    this.instructor = this.info.instructor;
    if (!this.instructor) {
      await this.$router.push('/instructor/directory?not_found=true');
    }
    this.loading = false;
  },
  methods: {
    hasSessions (format) {
      return this.courses[format] && this.courses[format].length > 0;
    },
  },
};
